import styled from 'styled-components';
import DropdownArrow from '../../../Shared/DropdownArrow';
import DropDown from '../../../Shared/DropdownContent';
import Button from '../../../Shared/MenuButton';

const scrollBarWidthInPx = 5;
const dropDownWidthInPx = 375;
const gradientBoxWidthInPx = 370;
const supportMenuBorderRadiusInPx = '3px';

export const StyledDropDown = styled(DropDown)`
  background-color: ${props => props.theme.header.background};
  right: 16px;
  top: 55px;
  border-radius: ${supportMenuBorderRadiusInPx};
  width: ${dropDownWidthInPx}px;
  z-index: 99999;

  &.is-showing-banner {
    top: 105px;
  }

  ${props => props.isDropdownExpanded && 'display: block;'}

  &:after {
    border-bottom-color: ${props => props.theme.header.background};
  }

  &:before {
    height: 25px;
  }

  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  box-sizing: border-box;
  font-family: "Brandon Text",Lato,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  a {
    text-decoration: none;
  }
  p {
    margin-top: 0;
  }
  * {
    box-sizing: border-box;
  }
  button {
    font-family: inherit;
  }
`;

export const StyledButton = styled(Button)`
  color: ${props => props.theme.carvana.white.primary};
  font-size: 11px;
  white-space: nowrap;
`;

export const StyledArrowDropDown = styled(DropdownArrow)`
  fill: ${({ isDropdownExpanded, theme }) =>
    (isDropdownExpanded ? theme.carvana.blue.primary : theme.carvana.white.primary)};
  width: 9px;
`;

export const MenuTitle = styled.div`
  color: ${({ isDropdownExpanded, theme }) =>
    (isDropdownExpanded ? theme.carvana.blue.primary : theme.carvana.white.primary)};
`;

export const MenuWrapper = styled.div`
  border-left: 1px solid ${props => props.theme.header.stroke};
  display: inline-flex;
  padding: 5px 0px 5px 32px;
  position: relative;
  ${props => props.isDropdownExpanded && 'z-index: 101;'}
`;

export const OutsideClickWrapper = styled.div`
  display: none;
  ${props => props.isDropdownExpanded && 'display: block;'}
  background: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
`;

export const DropDownHeader = styled.div`
  background: ${props => props.theme.carvana.blue.medium};
  position: absolute;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${supportMenuBorderRadiusInPx};
  box-shadow: 0 2px 3px ${props => props.theme.header.boxShadow};

  svg {
    margin-right: 12px;
    cursor: pointer;
  }
`;

export const DropDownHeaderText = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: ${props => props.theme.carvana.white.primary};
  text-transform: uppercase;
`;

export const DropDownHeaderSpace = styled.div`
  flex: 1;
`;

export const DropDownHeaderIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  &:focus {
    outline: none;
  }
`;

export const GradientBox = styled.div`
  pointer-events: none;
  z-index: 11;
  padding-right: 5px;
  width: ${gradientBoxWidthInPx}px;
  height: 123px;
  position: absolute;
  left: 0;
  bottom: 0;
  border-radius: ${supportMenuBorderRadiusInPx};
  background: linear-gradient(transparent, ${props => props.theme.carvana.blue.medium});
`;

export const DropDownContent = styled.div`
  overflow: auto;
  max-height: 650px;
  border-radius: ${supportMenuBorderRadiusInPx};

  > div:last-child {
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar {
    width: ${scrollBarWidthInPx}px;
    background: ${props => props.theme.header.stroke};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.carvana.blue.dark};
    border-radius: 4px;
  }
`;

export const InnerDropDown = styled.div`
  padding-top: 44px;
  position: relative;
`;

export const PortalContentWrapper = styled.div`
  display: none;
  ${props => props.isDropdownExpanded && 'display: block;'}
  width: 100%;
  height: 0;
`;

export const PortalContentInnerWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 0;
  top: 0;
  right: 0;
  left: 0;
  margin: 0 auto;

  &.has-max-width {
    max-width: ${props => props.theme.breakpoints.values.xl}px;
  }
`;
